/**
 * Deployed build version, shown in the sidebar footer (mirrors the project /
 * cab tenants).
 *
 * Injected by Vite at build time from VITE_APP_VERSION, which the SWA pipeline
 * (azure-pipelines-oscar-site.yml) sets to the Azure DevOps build number
 * (e.g. "20260616.3"). Falls back to 'dev' for local `npm run dev` /
 * `npm run build` where the var is unset — no manual bumping.
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'dev';
